import { PortableText } from '@portabletext/react';
import { graphql } from 'gatsby';
import React from 'react';
import { getComponents } from '../../../portableText';
import { RawPortableText } from '../../../types/types';
import { CommonModuleProps } from '../../ModulesContent';
import ModuleLayout from '../ModuleLayout';
import * as styles from './RichTextModule.module.scss';

export const RichTextModuleFragment = graphql`
  fragment RichTextModule on SanityRichTextModule {
    text {
      ...LocalePortableText
    }
  }
`;

export type RichTextModuleProps = {
  text: RawPortableText;
  className?: string;
};

function RichTextModule(props: RichTextModuleProps & CommonModuleProps): React.ReactElement {
  const { text, className, moduleId } = props;

  return (
    <ModuleLayout
      id={moduleId}
      className={className}
      childrenClassName={styles.contentContainer}
      currentModuleBgColor={props.theme}
    >
      <div className={styles.text}>
        <PortableText value={text} components={getComponents()} />
      </div>
    </ModuleLayout>
  );
}

export default RichTextModule;
